// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","732":"fda73a07","977":"f9b5d192"}[chunkId] + ".chunk.js";
};